import { getStyleSheet } from './style-sheet-memo';

export const height = (height: number | string | undefined) =>
  getStyleSheet({ height });

export const width = (width: number | string | undefined) =>
  getStyleSheet({ width });

export const minWidth = (minWidth: number | string) =>
  getStyleSheet({ minWidth });

export const maxWidth = (maxWidth: number | string) =>
  getStyleSheet({ maxWidth });

export const maxHeight = (maxHeight: number | string) =>
  getStyleSheet({ maxHeight });

export const minHeight = (minHeight: number | string) =>
  getStyleSheet({ minHeight });

export const gap = (gap: number | undefined) => getStyleSheet({ gap });
